export default [
  {
    title: 'Customers',
    icon: 'UsersIcon',
    children: [
      {
        title: 'Files',
        route: 'customers-files-index',
        icon: 'FileIcon',
        resource: 'File',
        action: 'read',
        parent: 'customers',
      },
      {
        title: 'Customers',
        route: 'customers-customers-index',
        icon: 'UsersIcon',
        resource: 'Customer',
        action: 'read',
        parent: 'customers',
      },
      {
        title: 'Invoices',
        route: 'customers-invoices-index',
        icon: 'FileIcon',
        parent: 'customers',
        resource: 'Invoice',
        action: 'read',
      },
      {
        title: 'Payments/Receipts',
        route: 'customers-receipts-index',
        icon: 'CreditCardIcon',
        parent: 'customers',
        resource: 'Receipt',
        action: 'read',
      },
      // {
      //   title: 'Customer Requests',
      //   route: 'app-customer-requests-index',
      //   icon: 'AlertCircleIcon',
      //   parent: 'customers',
      //   resource: 'CustomerRequest',
      //   action: 'read',
      // },
      {
        title: 'Customer Requests',
        icon: 'AlertCircleIcon',
        parent: 'customers',
        children: [
          {
            title: 'Change Profile Requests',
            route: 'app-customer-requests-index',
            icon: '',
            params: {
              type: 'profile-change',
            },
            resource: 'CustomerRequest',
            action: 'read',
          },
          {
            title: 'Transfer of Ownerships Requests',
            route: 'app-customer-requests-index',
            icon: '',
            params: {
              type: 'transfer-ownership',
            },
            resource: 'TransferOwnership',
            action: 'read',
          },
          {
            title: 'Change of Purchaser Requests',
            route: 'app-customer-requests-index',
            icon: '',
            params: {
              type: 'change-purchaser',
            },
            resource: 'ChangePurchaser',
            action: 'read',
          },
        ],
      },
      // {
      //   title: 'Entitlements',
      //   route: 'customers-entitlements-index',
      //   params: {
      //     type: 'all-entitlement',
      //   },
      //   icon: 'GiftIcon',
      //   parent: 'customers',
      //   resource: 'Entitlement',
      //   action: 'read',
      // },
    ],
  },
]
